<p-table
  [value]="page.items"
  [responsive]="true"
  resizableColumns="true"
  class="fixed-table"
  [(selection)]="selectedSetting"
  selectionMode="single"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name">Name <p-sortIcon [field]="'name'"></p-sortIcon></th>
      <th pSortableColumn="value">Value <p-sortIcon [field]="'value'"></p-sortIcon></th>
      <th pSortableColumn="lastUpdateDate">
        Last Updated <p-sortIcon [field]="'lastUpdateDate'"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item" (dblclick)="editSetting(item)">
      <td>{{ item.name }}</td>
      <td>{{ item.value }}</td>
      <td>{{ item.lastUpdateDate | datex : 'ddd DD MMM HH:mm' }}</td>
    </tr>
  </ng-template>
</p-table>

<!--- DATATABLE DEPRECATED ---

<p-dataTabl [value]="page.items" [responsive]="true" resizableColumns="true" class="fixed-table"
             [(selection)]="selectedSetting" selectionMode="single" (onRowDblclick)="editSetting(selectedSetting)">

    <p-column field="name" header="Name" [sortabl]="true" [editable]="false"></p-column>
    <p-column field="value" header="Value" [sortabl]="true" [editable]="false" styleClass="fixed-width-value"></p-column>
    <p-column field="lastUpdateDate" header="Last Updated" [sortabl]="true" [editable]="false">
        <ng-template pTemplate="body" let-item="rowData">
            {{ item.lastUpdateDate | datex:'ddd DD MMM HH:mm' }}
        </ng-template>
    </p-column>
</p-dataTable>

-->

<p-dialog
  header="Edit Setting"
  [(visible)]="isShowSystemSetting"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '490px', height: '324px' }"
>
  <div class="ui-g" style="position: relative; height: 250px">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Name</label>
      </div>
      <div class="ui-grid-col-8">
        <input [(ngModel)]="setting.name" [style]="{ width: '100%' }" pInputText />
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Value</label>
      </div>
      <div class="ui-grid-col-8">
        <input
          pInputText
          style="width: 100%"
          [(ngModel)]="setting.value"
          (keydown.enter)="saveSetting(setting)"
        />
      </div>
    </div>

    <div style="width: 100%; height: 40px">
      <button
        type="button"
        (click)="isShowSystemSetting = false"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        class="ui-button btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        class="ui-button green-btn btn-to-right"
        (click)="saveSetting(setting)"
      ></button>
    </div>
  </div>
</p-dialog>
